import CountriesService from "@/services/countries/CountriesService";
import { useQuery } from "@tanstack/react-query";

export const COUNTRIES_QUERY_KEY = "countries";
export const STATES_QUERY_KEY = "states";

// ========== QUERIES ==========

export function useCountriesList() {
  return useQuery({
    queryKey: [COUNTRIES_QUERY_KEY],
    queryFn: () => CountriesService.getCountriesList().then((r) => r.getContentOrThrowError()),
    staleTime: Infinity, // Countries list doesn't change, cache forever
  });
}

export function useStatesList(iso2CountryCode: string) {
  return useQuery({
    queryKey: [STATES_QUERY_KEY, iso2CountryCode],
    queryFn: () => CountriesService.getStatesList(iso2CountryCode).then((r) => r.getContentOrThrowError()),
    enabled: !!iso2CountryCode,
    staleTime: Infinity, // States list doesn't change, cache forever
  });
}
